<template>
  <div class="biscuet-container">
    <div
      id="inspire"
      :style="bAppStyle"
    >
      <ClientExpiredNotification />
      <BLayout>
        <VaAppHeader />
        <RouterView :key="$route.fullPath" />
      </BLayout>

      <!-- Zoom Phone機能 -->
      <ZoomPhoneWidget />
      <ZoomPhoneToggleButton />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, provide } from 'vue';
import ClientExpiredNotification from '@/components/organisms/ClientExpiredNotification.vue';
import VaAppHeader from '@/components/organisms/va-app/VaAppHeader.vue';
import ZoomPhoneToggleButton from '@/components/organisms/va-app/zoom-phone-widget/ZoomPhoneToggleButton.vue';
import ZoomPhoneWidget from '@/components/organisms/va-app/zoom-phone-widget/ZoomPhoneWidget.vue';
import {
  REFRESH_CALL_LIST_KEY,
  TRACK_VOICE_ANALYSIS_KEY,
  type TRefreshCallList,
  type TTrackVoiceAnalysis,
} from '@/composable/va-app/zoom-phone-widget/injection-keys';
import { ZOOM_PHONE_WIDGET_VISIBLE_KEY } from '@/composable/va-app/zoom-phone-widget/zoom-phone-widget-visible';

const bAppStyle = {
  width: '100%',
};
// =======================================================
// NOTE: Zoom Phone Widget 関連の provide処理
// =======================================================
const zoomPhoneWidgetVisible = ref(false);
provide(ZOOM_PHONE_WIDGET_VISIBLE_KEY, zoomPhoneWidgetVisible);

const refreshCallList = ref<TRefreshCallList>(async () => {
  // NOTE:CallList.vue がマウントされる前は何もしない
});
provide(REFRESH_CALL_LIST_KEY, refreshCallList);

const trackVoiceAnalysis = ref<TTrackVoiceAnalysis>(() => {
  // NOTE:CallList.vue がマウントされる前は何もしない
});
provide(TRACK_VOICE_ANALYSIS_KEY, trackVoiceAnalysis);
// =======================================================
</script>

<style lang="scss" scoped>
.biscuet-container {
  @include m-fixed-height(100vh);
  display: flex;
  position: relative;
  max-width: 100%;
  overflow: hidden;
}
</style>
